import analytics from '@utils/analytics';
import { HIRES, LG, MD, SM } from '@utils/imageutils';
import useBreakpoint from '@utils/useBreakpoint';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SwiperCore, { EffectFade, Keyboard, Pagination } from 'swiper';
import { Swiper as SwiperInstance, SwiperSlide } from 'swiper/react';
import ProductImage from './ProductImage';
import ProductImageButton from './ProductImageButton';
import ProductVideo from './ProductVideo';
import ProductVerticalGallery from './ProductVerticalGallery';
SwiperCore.use([Pagination, EffectFade, Keyboard]);
const imageSizes = [SM, MD, LG, HIRES];
const ProductHero = (props) => {
    const { t } = useTranslation();
    const { product } = props;
    const [swiper, setSwiper] = useState(null);
    const breakpoint = useBreakpoint();
    const swiperRef = useRef();
    const [pressed, setPressed] = useState(false);
    let containerBullets = document.querySelector('.swiper-pagination-bullets');
    const isTablet = breakpoint < window.mqObj.lg && breakpoint >= window.mqObj.sm;
    const callback = (entries) => {
        let wrapperBullets = document.querySelector('.container-pagination');
        let wrapperButtonVideo = document.querySelector('.container-product-button-video-temp');
        entries.forEach((entry) => {
            if (wrapperBullets) {
                if (entry.isIntersecting) {
                    wrapperBullets.classList.remove('fixed');
                    wrapperButtonVideo.classList.remove('fixed');
                }
                else {
                    if (entry.boundingClientRect.y > 100) {
                        wrapperBullets.classList.add('fixed');
                        wrapperButtonVideo.classList.add('fixed');
                    }
                }
            }
        });
    };
    const observer = useRef(new IntersectionObserver(callback, { threshold: 1, rootMargin: '-64px' })).current;
    // intersection observer on stickyTray
    useEffect(() => {
        let wrapperBullets = document.querySelector('.container-pagination');
        if (breakpoint >= window.mqObj.sm && breakpoint < window.mqObj.lg) {
            if (containerBullets && wrapperBullets) {
                observer.observe(wrapperBullets);
            }
        }
        return () => {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        };
    }, [breakpoint, containerBullets]);
    useEffect(() => {
        if (swiper && breakpoint < window.mqObj.lg) {
            swiper.slideTo(1);
        }
    }, [product]);
    const heroGalleryImage = (mediaUrl, index) => {
        var _a, _b;
        return (React.createElement(React.Fragment, null,
            React.createElement(ProductImageButton, { onImageClick: () => props.onImageClick(index), clicked: props.clicked === index, ariaLabel: t('button.openProductGallery', { productName: (_a = product === null || product === void 0 ? void 0 : product.imgs) === null || _a === void 0 ? void 0 : _a.alt, index: index + 1, total: props.media.length }) }, mediaUrl.includes('_V1') ||
                mediaUrl.includes('_V2') ||
                mediaUrl.includes('_V3') ||
                mediaUrl.includes('_V4') ||
                mediaUrl.includes('_V5') ||
                mediaUrl.includes('_V6') ||
                mediaUrl.includes('_V7') ||
                mediaUrl.includes('_V8') ||
                mediaUrl.includes('_V9') ||
                mediaUrl.includes('_V10') ? (React.createElement("div", { className: "product-image" },
                React.createElement("div", { className: "product-video-wrapper" },
                    React.createElement(ProductVideo, { url: mediaUrl, isParfum: product === null || product === void 0 ? void 0 : product.isParfum })))) : (React.createElement(ProductImage, Object.assign({ img: { alt: (_b = product === null || product === void 0 ? void 0 : product.imgs) === null || _b === void 0 ? void 0 : _b.alt, urls: props.media }, sizes: imageSizes, index: index, productId: index == 0 ? product === null || product === void 0 ? void 0 : product.id : undefined }, (index === 0 && { lazyDisabled: true }), { animatedImage: true })))),
            (mediaUrl.includes('_V1') ||
                mediaUrl.includes('_V2') ||
                mediaUrl.includes('_V3') ||
                mediaUrl.includes('_V4') ||
                mediaUrl.includes('_V5') ||
                mediaUrl.includes('_V6') ||
                mediaUrl.includes('_V7') ||
                mediaUrl.includes('_V8') ||
                mediaUrl.includes('_V9') ||
                mediaUrl.includes('_V10')) && (React.createElement("div", { className: `container-product-button-video fixed ${isTablet ? 'd-none' : ''}` },
                React.createElement("button", { className: "product-video-pause is-parfum", "aria-label": t('button.pause'), "data-pause": true, "aria-pressed": "false" })))));
    };
    return (React.createElement(React.Fragment, null,
        props.media.length == 0 && (React.createElement("div", { className: "product-image-button product-hero-skeleton" },
            React.createElement("div", { className: "product-image" }))),
        props.media.length > 0 &&
            //@ts-ignore
            (breakpoint >= window.mqObj['md'] ? (React.createElement(React.Fragment, null,
                React.createElement(ProductVerticalGallery, Object.assign({}, props)),
                (product === null || product === void 0 ? void 0 : product.VTOcode) && (React.createElement("button", { onClick: () => {
                        analytics.vtoPdpGeneric(product === null || product === void 0 ? void 0 : product.id);
                        props.openVto();
                    }, className: "toggle-vto prova" },
                    React.createElement("i", { className: "icon--vto" }),
                    React.createElement("span", null, t('label.taptotry')))))) : (React.createElement(React.Fragment, null,
                React.createElement(SwiperInstance, { className: "product-hero-gallery", effect: "fade", speed: 1000, loop: true, slidesPerView: 1, loopPreventsSlide: false, keyboard: true, threshold: 1, touchRatio: 2, longSwipesRatio: 1, edgeSwipeDetection: true, pagination: {
                        clickable: true,
                        el: '#pagination-bullets',
                    }, navigation: {
                        nextEl: `.product-hero-carousel__next`,
                        prevEl: `.product-hero-carousel__prev`,
                    }, followFinger: false, onSwiper: setSwiper, onActiveIndexChange: (swiper) => {
                        if (isTablet) {
                            let nextSlide = swiper === null || swiper === void 0 ? void 0 : swiper.slides[swiper.realIndex + 1];
                            let productVideo = nextSlide === null || nextSlide === void 0 ? void 0 : nextSlide.querySelector('.product-video-wrapper');
                            if (productVideo) {
                                document.querySelector('.container-product-button-video-temp').classList.add('d-block');
                                let pauseVideo = nextSlide.querySelector('.product-video-pause');
                                pauseVideo === null || pauseVideo === void 0 ? void 0 : pauseVideo.click();
                                let isPressed = pauseVideo.getAttribute('aria-pressed') === 'true';
                                setPressed(isPressed);
                            }
                            else {
                                document.querySelector('.container-product-button-video-temp').classList.remove('d-block');
                            }
                        }
                    } },
                    props.media.map((url, index) => {
                        var _a;
                        return (React.createElement(SwiperSlide, { key: `${(_a = props.product) === null || _a === void 0 ? void 0 : _a.id}${index}` },
                            React.createElement("div", { className: "product-gallery", key: `${product === null || product === void 0 ? void 0 : product.id}${index}` },
                                index == 0 && (product === null || product === void 0 ? void 0 : product.VTOcode) && (React.createElement("button", { onClick: () => {
                                        analytics.vtoPdpGeneric(product === null || product === void 0 ? void 0 : product.id);
                                        props.openVto();
                                    }, className: "toggle-vto" },
                                    React.createElement("i", { className: "icon--tap-vto" }),
                                    React.createElement("span", null, t('label.taptotry')))),
                                heroGalleryImage(url, index))));
                    }),
                    React.createElement("div", { className: "container-pagination fixed" },
                        React.createElement("div", { id: "pagination-bullets", className: "swiper-pagination" })),
                    isTablet && (React.createElement("div", { className: "container-product-button-video-temp" },
                        React.createElement("button", { className: "product-video-pause is-parfum", "aria-label": t('button.pause'), onClick: () => {
                                var _a;
                                let pauseVideo = (_a = swiper === null || swiper === void 0 ? void 0 : swiper.el) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper-slide-active .product-video-pause');
                                console.log('swiper ->', swiper);
                                console.log('pauseVideo ->', pauseVideo);
                                pauseVideo === null || pauseVideo === void 0 ? void 0 : pauseVideo.click();
                                let isPressed = pauseVideo.getAttribute('aria-pressed') === 'true';
                                setPressed(isPressed);
                            }, "aria-pressed": pressed }))),
                    React.createElement("div", { className: "" },
                        React.createElement("button", { type: "button", className: `button button--tertiary-inverted button--arrow-left product-hero-carousel__prev` }),
                        React.createElement("button", { type: "button", className: `button button--tertiary-inverted button--arrow-right product-hero-carousel__next` }))))))));
};
export default ProductHero;
